import type { FC } from "react";
import type { DialogController } from "../../../../utils/hooks/use-dialog";
import type { SegmentCrudDialogState } from "./hooks/use-segment-crud-datagrid-dialog";

import { SegmentCrudDataGridDialogV2 } from "./segment-crud-data-grid-dialog-v2";
import type { SegmentRowWithOptions } from "./types";

export const SegmentCrudDataGridDialog: FC<{
  dialog: DialogController<SegmentCrudDialogState>;
  is_recipient_type: boolean;
  reload: () => void;
  processedSegments: SegmentRowWithOptions[];
}> = ({ dialog, ...props }) => {
  if (!dialog.data || !dialog.open) return null;

  return <SegmentCrudDataGridDialogV2 {...props} dialog={dialog} />;
};
